// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueReservations = (newValue) => ({
  type: actionTypes.SET_VALUE_RESERVATION,
  payload: newValue,
});

export const setCurrentPageReservations = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_RESERVATION,
  payload: newCurrentPage,
});

export const setSortingReservations = (newSorting) => ({
  type: actionTypes.SET_SORTING_RESERVATION,
  payload: newSorting,
});
export const setPageSizeReservations = (newValue) => ({
  type: actionTypes.SET_PAGE_SIZE_RESERVATION,
  payload: newValue,
});

export const setCustomFilterReservations = (newValue) => ({
  type: actionTypes.SET_CUSTOM_FILTERS_RESERVATION,
  payload: newValue,
});
export const setSortFieldReservations = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_RESERVATION,
  payload: newSortField,
});
export const setOrderReservations = (newOrder) => ({
  type: actionTypes.SET_ORDER_RESERVATION,
  payload: newOrder,
});
export const setActiveTabReservations = (newActiveTab) => ({
  type: actionTypes.SET_ACTIVE_TAB_RESERVATION,
  payload: newActiveTab,
});
export const setQueryReservations = (newQuery) => ({
  type: actionTypes.SET_QUERY_RESERVATION,
  payload: newQuery,
});
export const setActifReservations = (newQuery) => ({
  type: actionTypes.SET_ACTIF_RESERVATION,
  payload: newQuery,
});
export const setSelectedOptionFiltersReservations = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_FILTERS_RESERVATION,
  payload: newQuery,
});
export const setSelectedOptionIdReservations = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_ID_RESERVATION,
  payload: newQuery,
});

export const setColumnReservations = (newValue) => ({
  type: actionTypes.SET_COLUMN_RESERVATION,
  payload: newValue,
});
